import { jsx as _jsx } from "react/jsx-runtime";
import { CopyViewModel, HoursEditorViewModel, applyHoursNotes } from "@lumora/core";
import { createContext, useContext, useMemo } from "react";
import { useViewModel } from "../react/useViewModel.js";
const READ_ONLY = {
    canEdit: false,
    resolve: (_key, fallback) => fallback,
    commit: async () => false,
    saving: null,
    errors: {},
    overrides: {},
    saveField: null,
    hours: null,
};
const CopyContext = createContext(READ_ONLY);
export function useCopy() {
    return useContext(CopyContext);
}
/** Binds the copy ViewModel to React for the subtree (the host wraps the public pages once). */
export function CopyProvider({ copy, hours, canEdit, saveField, children }) {
    const state = useViewModel(copy);
    const value = useMemo(() => ({
        canEdit,
        resolve: (key, fallback) => state.overrides[key] ?? fallback,
        commit: (key, text) => copy.commit(key, text),
        saving: state.saving,
        errors: state.errors,
        overrides: state.overrides,
        saveField: saveField ?? null,
        hours: hours ?? null,
    }), [canEdit, copy, hours, saveField, state]);
    return _jsx(CopyContext.Provider, { value: value, children: children });
}
/** Mon-Sun rows with the owner's per-day notes ("By appointment") applied. */
export function useHoursRows(rows) {
    const { overrides } = useCopy();
    return applyHoursNotes(rows, overrides);
}
//# sourceMappingURL=CopyContext.js.map